import './title7.css'
export default function Title7(){
    return(
        <>
       <div className="h"> <div className="head-7">
       </div></div>
        <div className="t">
        <h3 className='t-1'>Bread Crumbs</h3>
        </div>
        </>
    )
}